import { getJWTFromStorage } from "./localStorage";

export const isGuestUser = async (): Promise<boolean> => {
  const token = await getJWTFromStorage();

  return !!!token;
};
